import axios from "../axiosInstance";

class AnttStatusService {
  async getAnttStatusList() {
    return await axios.get("anttstatus");
  }
}

export default new AnttStatusService();
